import {Component, ElementRef, ViewChild} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	template: '<info-modal [title]="title" (onOk)="ok()"><iframe style="width: 100%; height: 500px; border: 0px;" #iframe></iframe></info-modal>'
})
export class MailBodyModalComponent extends InfoModalComponent {
	@ViewChild('iframe', { static: true }) iframe: ElementRef;
	private _body: string;
	title: string = 'Loading...';

	set body(body: string) {
		this._body = body;

		this.iframe.nativeElement.contentWindow.document.body.innerHTML = this._body;
	}

	ok() {
		this.close();
	}
}
